import { jsx } from 'react/jsx-runtime';
import { Suspense, Children } from 'react';

const Route = ({
  children,
  fallback
}) => {
  return /* @__PURE__ */ jsx(Suspense, { fallback, children });
};

const removePrefix = (current, prefix) => {
  if (prefix?.length) {
    return current.substring(prefix.length + 1);
  }
  return current;
};
const routeFilter = (route) => route.type === Route;
const toRouteArray = (children) => Children.toArray(children).filter(routeFilter);
const extractRoutePaths = (routes) => routes.map((route) => route.props.path);
const findRouteByPath = (routes, path) => routes.find((route) => route.props.path === path);
const pathMatcher = (path, current) => path.endsWith("/*") && current.startsWith(path.substring(0, path.length - 1));
const findRouteByWildcard = (routes, path) => routes.find((route) => pathMatcher(route.props.path, path));
const findRoute = (routes, path) => findRouteByPath(routes, path) || findRouteByWildcard(routes, path);

const Router = ({ current, prefix, children }) => {
  const routeToDisplay = findRoute(
    toRouteArray(children),
    removePrefix(current, prefix)
  );
  if (!routeToDisplay) {
    const withPrefix = prefix?.length ? `, with prefix [${prefix}]` : "";
    const availableRoutes = extractRoutePaths(toRouteArray(children));
    throw Error(`No route found for path [${current}]${withPrefix}, available routes are [${availableRoutes}]!`);
  }
  return routeToDisplay;
};

export { Route, Router };
